import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { Shop } from '@app/services/shops/shop.model';
import { ShopService } from '@app/services/shops/shop.service';
import moment from 'moment';

import { combineLatest, forkJoin } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { RedashReportsService } from '../redash-reports.service';

@Component({
  selector: 'report-downloader',
  templateUrl: './report-downloader.component.html',
  styleUrls: ['./report-downloader.component.scss'],
  standalone: false,
})
export class ReportDownloaderComponent implements OnInit {
  params: any;
  reportId: number;

  statusText = 'Your download will be ready soon';

  private destroyRef = inject(DestroyRef);

  constructor(
    private _route: ActivatedRoute,
    private reportsSrv: RedashReportsService,
    private _shopService: ShopService,
  ) {}

  ngOnInit(): void {
    combineLatest([this._route.params, this._route.queryParams])
      .pipe(take(1), takeUntilDestroyed(this.destroyRef))
      .subscribe(([p, qp]) => {
        this.reportId = p?.id;
        this.params = qp;
        this.getReport();
      });
  }

  getReport() {
    const shop$ = this._shopService.shop$.pipe(
      filter((shop): shop is Shop => !!shop),
      take(1),
    );
    const report$ = this.reportsSrv.getReportData(this.reportId, this.params);

    forkJoin([shop$, report$])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: ([shop, report]) => {
          const timestamp = moment().format('DD-MM-yyyy');
          const fileName = `${shop?.title ? shop.title + '_' : ''}${this.reportId}_${timestamp}`;
          this.reportsSrv.downloadFile(report, fileName);
          this.statusText = 'Report downloaded successfully';
        },
        error: () => {
          this.statusText = 'Failed to get report, check your parameters and try again.';
        },
      });
  }
}
